"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteJsonUtil = exports.TwisterchainIproProduktgruppenIds = exports.TwisterbandIproProduktgruppenIds = exports.RXIproProduktgruppenIds = exports.ESkinIproProduktgruppenIds = exports.TriflexRIproProduktgruppenIds = exports.KetteBasePriceCalculationType = exports.KetteBestellTyp = void 0;
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const echain_shared_logging_1 = require("@igus/echain-shared-logging");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const Eskin_1 = require("./Eskin");
const eSkinAeExcessLengthMap_1 = require("./eSkinAeExcessLengthMap");
const KetteCalculator_1 = require("./KetteCalculator");
const KetteSerieType_1 = require("./KetteSerieType");
/**
 * Defines Bestelltyp for Kette
 * See https://igusdev.atlassian.net/wiki/spaces/MMACR/pages/577634612/01+-+igus+Warenkorb at Bestelltyp
 */
var KetteBestellTyp;
(function (KetteBestellTyp) {
    KetteBestellTyp[KetteBestellTyp["Undefined"] = 0] = "Undefined";
    KetteBestellTyp[KetteBestellTyp["Kette"] = 400] = "Kette";
    KetteBestellTyp[KetteBestellTyp["KetteUK"] = 401] = "KetteUK";
    KetteBestellTyp[KetteBestellTyp["KetteUS"] = 402] = "KetteUS";
    KetteBestellTyp[KetteBestellTyp["KetteAlternative"] = 300] = "KetteAlternative";
})(KetteBestellTyp = exports.KetteBestellTyp || (exports.KetteBestellTyp = {}));
/**
 * Defines how to calculate the BasPrice for a Kette
 * PerExactLength: calculates for a length of exactly 1m
 * PerFullKettenglied: calculates with the length of the shortest possible chain with a length of at least 1m constructed of full Kettenglieder
 *
 */
var KetteBasePriceCalculationType;
(function (KetteBasePriceCalculationType) {
    KetteBasePriceCalculationType[KetteBasePriceCalculationType["PerExactLength"] = 0] = "PerExactLength";
    KetteBasePriceCalculationType[KetteBasePriceCalculationType["PerFullKettenglied"] = 1] = "PerFullKettenglied";
})(KetteBasePriceCalculationType = exports.KetteBasePriceCalculationType || (exports.KetteBasePriceCalculationType = {}));
/**
 * Defines IproProduktgruppenIds for triflex® R chains
 */
var TriflexRIproProduktgruppenIds;
(function (TriflexRIproProduktgruppenIds) {
    // IMPORTANT!: If add new IproProduktgruppenId here add it in iProExporter in ChainExport.cs too
    TriflexRIproProduktgruppenIds[TriflexRIproProduktgruppenIds["TRC"] = 33] = "TRC";
    TriflexRIproProduktgruppenIds[TriflexRIproProduktgruppenIds["TRE"] = 37] = "TRE";
    TriflexRIproProduktgruppenIds[TriflexRIproProduktgruppenIds["TRL"] = 38] = "TRL";
    // IMPORTANT!: If add new IproProduktgruppenId here add it in iProExporter in ChainExport.cs too
})(TriflexRIproProduktgruppenIds = exports.TriflexRIproProduktgruppenIds || (exports.TriflexRIproProduktgruppenIds = {}));
/**
 * Defines IproProduktgruppenIds for e-skin chains
 */
var ESkinIproProduktgruppenIds;
(function (ESkinIproProduktgruppenIds) {
    ESkinIproProduktgruppenIds[ESkinIproProduktgruppenIds["eskin"] = 76] = "eskin";
})(ESkinIproProduktgruppenIds = exports.ESkinIproProduktgruppenIds || (exports.ESkinIproProduktgruppenIds = {}));
/**
 * Defines IproProduktgruppenIds for RX Rohre chains
 */
var RXIproProduktgruppenIds;
(function (RXIproProduktgruppenIds) {
    RXIproProduktgruppenIds[RXIproProduktgruppenIds["rxRohre"] = 42] = "rxRohre";
})(RXIproProduktgruppenIds = exports.RXIproProduktgruppenIds || (exports.RXIproProduktgruppenIds = {}));
/**
 * Defines IproProduktgruppenIds for twisterband chains
 */
var TwisterbandIproProduktgruppenIds;
(function (TwisterbandIproProduktgruppenIds) {
    TwisterbandIproProduktgruppenIds[TwisterbandIproProduktgruppenIds["twisterband"] = 46] = "twisterband";
})(TwisterbandIproProduktgruppenIds = exports.TwisterbandIproProduktgruppenIds || (exports.TwisterbandIproProduktgruppenIds = {}));
/**
 * Defines IproProduktgruppenIds for twisterchain chains
 */
var TwisterchainIproProduktgruppenIds;
(function (TwisterchainIproProduktgruppenIds) {
    TwisterchainIproProduktgruppenIds[TwisterchainIproProduktgruppenIds["twisterchain"] = 21] = "twisterchain";
    TwisterchainIproProduktgruppenIds[TwisterchainIproProduktgruppenIds["twisterchainNew"] = 48] = "twisterchainNew";
})(TwisterchainIproProduktgruppenIds = exports.TwisterchainIproProduktgruppenIds || (exports.TwisterchainIproProduktgruppenIds = {}));
/**
 * The `KetteJsonUtil` provides utility functions for `KetteJson`
 */
class KetteJsonUtil {
    /**
     * Retrieves true if the Verfahrweg calculation is based on standard formula
     */
    static hasStandardVerfahrwegCalculation(ketteJson) {
        const type = ketteJson.KetteSerieType;
        switch (type) {
            case KetteSerieType_1.KetteSerieType.default:
            case KetteSerieType_1.KetteSerieType.rxRohr:
                return true;
            case undefined:
            case KetteSerieType_1.KetteSerieType.triflexR:
            case KetteSerieType_1.KetteSerieType.eskin:
            case KetteSerieType_1.KetteSerieType.twisterband:
            case KetteSerieType_1.KetteSerieType.twisterchain:
            case KetteSerieType_1.KetteSerieType.rolEchain:
            case KetteSerieType_1.KetteSerieType.trxe:
                return false;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
    }
    /**
     * Retrieves all available kuerzel in the list
     */
    static getAllSerieKuerzel(ketteJsons) {
        const allSerieKuerzel = new Set();
        for (const ketteJson of ketteJsons) {
            if (ketteJson.SerieRef && ketteJson.SerieRef.Kuerzel) {
                allSerieKuerzel.add(ketteJson.SerieRef.Kuerzel);
            }
        }
        return Array.from(allSerieKuerzel);
    }
    /**
     * Retrieves all available ids with kuerzel in the list
     */
    static getAllSerieIdWithKuerzel(ketteJsons) {
        const allSerieRefJson = [];
        for (const ketteJson of ketteJsons) {
            if (ketteJson.SerieRef && ketteJson.SerieRef.Id && ketteJson.SerieRef.Kuerzel) {
                if (!allSerieRefJson.find((ref) => { var _a, _b; return ref.Id === ((_a = ketteJson.SerieRef) === null || _a === void 0 ? void 0 : _a.Id) && ref.Kuerzel === ((_b = ketteJson.SerieRef) === null || _b === void 0 ? void 0 : _b.Kuerzel); })) {
                    allSerieRefJson.push({ Id: ketteJson.SerieRef.Id, Kuerzel: ketteJson.SerieRef.Kuerzel });
                }
            }
        }
        return allSerieRefJson;
    }
    /**
     * Retrieves a KetteJson with given ArtNr
     */
    static findByArtNr(ketteJsons, artNr) {
        return ketteJsons.find((ketteJson) => { var _a; return ketteJson.ArtNr && ((_a = ketteJson.ArtNr[echain_shared_i18n_1.LocaleService.getArtNrCountry()]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === artNr.toUpperCase(); });
    }
    /**
     * Retrieves a new KetteJson array filtered by given starting part of the ArtNr
     */
    static filterByStartingArtNrPart(ketteJsons, startingArtNrPart) {
        const startingArtNrPartUpperCase = startingArtNrPart.toUpperCase();
        const artNrCountry = echain_shared_i18n_1.LocaleService.getArtNrCountry();
        return ketteJsons.filter((ketteJson) => { var _a; return ketteJson.ArtNr && ((_a = ketteJson.ArtNr[artNrCountry]) === null || _a === void 0 ? void 0 : _a.toUpperCase().startsWith(startingArtNrPartUpperCase)); });
    }
    /**
     * Retrieves a new KetteJson array filtered by given serie kuerzel.
     */
    static filterBySerieKuerzel(ketteJsons, kuerzel) {
        const kuerzelUpperCase = kuerzel.toUpperCase();
        return ketteJsons.filter((ketteJson) => { var _a, _b; return ((_b = (_a = ketteJson.SerieRef) === null || _a === void 0 ? void 0 : _a.Kuerzel) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === kuerzelUpperCase; });
    }
    /**
     * Retrieves a new KetteJson array filtered by given system kuerzel.
     */
    static filterByEchainSystem(ketteJsons, echainSystem) {
        return ketteJsons.filter((ketteJson) => ketteJson.EchainSystem === echainSystem);
    }
    /**
     * Retrieves a new KetteJson array filtered by given id.
     */
    static filterById(ketteJsons, id) {
        return ketteJsons.filter((ketteJson) => ketteJson.SerieRef && ketteJson.SerieRef.Id === id);
    }
    /**
     * Retrieves detailed data for series
     */
    static groupBySerieId(ketteJsons, unitSystem) {
        const series = [];
        const seriesMap = {};
        ketteJsons.forEach((ketteJson) => {
            var _a;
            // eslint-disable-next-line
            const ketten = seriesMap[ketteJson.SerieRef.Id] ? seriesMap[ketteJson.SerieRef.Id].ketten : [];
            if (!ketten.find((kj) => kj.ArtNr === ketteJson.ArtNr))
                ketten.push(ketteJson);
            const aussenbreiten_mm = seriesMap[ketteJson.SerieRef.Id] // eslint-disable-line
                ? seriesMap[ketteJson.SerieRef.Id].aussenbreiten_mm // eslint-disable-line
                : [];
            // eslint-disable-next-line
            if (aussenbreiten_mm.indexOf(ketteJson.Aussenbreite_mm) === -1)
                aussenbreiten_mm.push(ketteJson.Aussenbreite_mm); // eslint-disable-line
            // eslint-disable-next-line
            const innenbreiten_mm = seriesMap[ketteJson.SerieRef.Id]
                ? seriesMap[ketteJson.SerieRef.Id].innenbreiten_mm // eslint-disable-line
                : [];
            // eslint-disable-next-line
            if (innenbreiten_mm.indexOf(ketteJson.Innenbreite_mm) === -1)
                innenbreiten_mm.push(ketteJson.Innenbreite_mm);
            const biegeradien_mm = seriesMap[ketteJson.SerieRef.Id] // eslint-disable-line
                ? seriesMap[ketteJson.SerieRef.Id].biegeradien_mm // eslint-disable-line
                : [];
            // eslint-disable-next-line
            if (biegeradien_mm.indexOf(ketteJson.Biegeradius_mm) === -1)
                biegeradien_mm.push(ketteJson.Biegeradius_mm);
            if (ketteJson.SerieRef && ketteJson.SerieRef.Id) {
                const standardLength = unitSystem === echain_shared_i18n_1.UnitSystem.metric ? echain_shared_quantities_1.Length.m(1) : echain_shared_quantities_1.Length.ft(1);
                seriesMap[ketteJson.SerieRef.Id] = {
                    id: ketteJson.SerieRef.Id,
                    kuerzel: ketteJson.SerieRef.Kuerzel || undefined,
                    aussenbreiten_mm,
                    innenbreiten_mm,
                    biegeradien_mm,
                    aussenhoehe_mm: ketteJson.Aussenhoehe_mm || undefined,
                    teilung_mm: ketteJson.Teilung_mm || undefined,
                    gliederPerStandardLength: ketteJson.Teilung_mm
                        ? KetteCalculator_1.KetteCalculator.calcNumGlieder(standardLength, echain_shared_quantities_1.Length.mm(ketteJson.Teilung_mm)) || undefined
                        : undefined,
                    openingPrincipleLabel: ketteJson.OpeningPrincipleLabel || undefined,
                    widenBildId: ketteJson.WidenBildId || undefined,
                    widenZeichnungId: ketteJson.WidenZeichnungId || undefined,
                    smartPlasticsECWAllowed: Boolean(ketteJson.SmartPlasticsECWAllowed),
                    hasEcwRefs: Boolean((_a = ketteJson.EcwRefs) === null || _a === void 0 ? void 0 : _a.length),
                    ketten,
                };
            }
        });
        const keys = Object.keys(seriesMap);
        keys.forEach((key) => series.push(seriesMap[parseInt(key, 10)]));
        return series;
    }
    static groupBySerieKuerzel(ketteJsons, unitSystem) {
        const series = [];
        const seriesMap = {};
        ketteJsons.forEach((ketteJson) => {
            var _a;
            // eslint-disable-next-line
            const ketten = seriesMap[ketteJson.SerieRef.Kuerzel]
                ? seriesMap[ketteJson.SerieRef.Kuerzel].ketten // eslint-disable-line
                : [];
            if (!ketten.find((kj) => kj.ArtNr === ketteJson.ArtNr))
                ketten.push(ketteJson);
            // eslint-disable-next-line
            const aussenbreiten_mm = seriesMap[ketteJson.SerieRef.Kuerzel]
                ? seriesMap[ketteJson.SerieRef.Kuerzel].aussenbreiten_mm // eslint-disable-line
                : [];
            // eslint-disable-next-line
            if (aussenbreiten_mm.indexOf(ketteJson.Aussenbreite_mm) === -1) {
                // eslint-disable-next-line
                aussenbreiten_mm.push(ketteJson.Aussenbreite_mm);
            }
            // eslint-disable-next-line
            const innenbreiten_mm = seriesMap[ketteJson.SerieRef.Kuerzel]
                ? seriesMap[ketteJson.SerieRef.Kuerzel].innenbreiten_mm // eslint-disable-line
                : [];
            // eslint-disable-next-line
            if (innenbreiten_mm.indexOf(ketteJson.Innenbreite_mm) === -1)
                innenbreiten_mm.push(ketteJson.Innenbreite_mm);
            // eslint-disable-next-line
            const biegeradien_mm = seriesMap[ketteJson.SerieRef.Kuerzel]
                ? seriesMap[ketteJson.SerieRef.Kuerzel].biegeradien_mm // eslint-disable-line
                : [];
            // eslint-disable-next-line
            if (biegeradien_mm.indexOf(ketteJson.Biegeradius_mm) === -1)
                biegeradien_mm.push(ketteJson.Biegeradius_mm);
            if (ketteJson.SerieRef && ketteJson.SerieRef.Kuerzel) {
                const standardLength = unitSystem === echain_shared_i18n_1.UnitSystem.metric ? echain_shared_quantities_1.Length.m(1) : echain_shared_quantities_1.Length.ft(1);
                seriesMap[ketteJson.SerieRef.Kuerzel] = {
                    id: ketteJson.SerieRef.Id,
                    kuerzel: ketteJson.SerieRef.Kuerzel || undefined,
                    aussenbreiten_mm,
                    innenbreiten_mm,
                    biegeradien_mm,
                    aussenhoehe_mm: ketteJson.Aussenhoehe_mm || undefined,
                    teilung_mm: ketteJson.Teilung_mm || undefined,
                    gliederPerStandardLength: ketteJson.Teilung_mm
                        ? KetteCalculator_1.KetteCalculator.calcNumGlieder(standardLength, echain_shared_quantities_1.Length.mm(ketteJson.Teilung_mm)) || undefined
                        : undefined,
                    openingPrincipleLabel: ketteJson.OpeningPrincipleLabel || undefined,
                    widenBildId: ketteJson.WidenBildId || undefined,
                    widenZeichnungId: ketteJson.WidenZeichnungId || undefined,
                    smartPlasticsECWAllowed: Boolean(ketteJson.SmartPlasticsECWAllowed),
                    hasEcwRefs: Boolean((_a = ketteJson.EcwRefs) === null || _a === void 0 ? void 0 : _a.length),
                    ketten,
                };
            }
        });
        const keys = Object.keys(seriesMap);
        keys.forEach((key) => series.push(seriesMap[key]));
        return series;
    }
    /**
     * Compares the given ketteJsons by the given attribute. This method complies to the usual compare
     * return values
     * (-1, 0, 1).
     */
    static compareByAttribute(ketteJsonA, ketteJsonB, attribute) {
        if (ketteJsonA[attribute] === ketteJsonB[attribute]) {
            return 0;
        }
        if (ketteJsonA[attribute] != null && ketteJsonB[attribute] == null) {
            return -1;
        }
        if (ketteJsonA[attribute] == null && ketteJsonB[attribute] != null) {
            return 1;
        }
        // eslint-disable-next-line
        return ketteJsonA[attribute] < ketteJsonB[attribute] ? -1 : 1;
    }
    /**
     * returns KetteJson Array filtered by Serie.Id And IndexBiegeradius
     */
    static getKetteJsonsBySerieAndBiegeradius(ketteJsons, inputKetteJson) {
        if (inputKetteJson.IndexBiegeradius && inputKetteJson.SerieRef && inputKetteJson.SerieRef.Id) {
            return ketteJsons.filter((ketteJson) => {
                var _a;
                return (ketteJson.SerieRef &&
                    ketteJson.SerieRef.Id &&
                    ketteJson.IndexBiegeradius &&
                    ketteJson.SerieRef.Id === ((_a = inputKetteJson === null || inputKetteJson === void 0 ? void 0 : inputKetteJson.SerieRef) === null || _a === void 0 ? void 0 : _a.Id) &&
                    ketteJson.IndexBiegeradius === inputKetteJson.IndexBiegeradius);
            });
        }
        else {
            return [];
        }
    }
    /**
     * returns a KetteJson array that only contains the smallest Kette (= the one with the smallest Innenbreite) for
     * each Serie of the given sourceKetteJsons
     */
    static getSmallestKettePerSerie(sourceKetteJsons) {
        const serieToKetteMapping = new Map();
        sourceKetteJsons.forEach((sourceKetteJson) => {
            var _a, _b;
            if (!sourceKetteJson.SerieRef || !sourceKetteJson.SerieRef.Id || !sourceKetteJson.Innenbreite_mm)
                return;
            if (!serieToKetteMapping.has(sourceKetteJson.SerieRef.Id)) {
                serieToKetteMapping.set(sourceKetteJson.SerieRef.Id, sourceKetteJson);
                return;
            }
            if (sourceKetteJson.Innenbreite_mm < ((_b = (_a = serieToKetteMapping === null || serieToKetteMapping === void 0 ? void 0 : serieToKetteMapping.get(sourceKetteJson.SerieRef.Id)) === null || _a === void 0 ? void 0 : _a.Innenbreite_mm) !== null && _b !== void 0 ? _b : 0))
                serieToKetteMapping.set(sourceKetteJson.SerieRef.Id, sourceKetteJson);
        });
        return Array.from(serieToKetteMapping.values());
    }
    /**
     * calculates the baseprice  for a kette for 1 length unit (e.g. 1m or 1ft) depending on the orderingType
     *
     * @param basePrice of a kette depending on the orderingType. Unit of the baseprice could be per Kettenglied or per length unit
     */
    static calculateBasePricePerLength(ketteJson, basePrice, orderingType, calculationType = KetteBasePriceCalculationType.PerFullKettenglied) {
        var _a;
        if (basePrice === -1)
            return undefined;
        switch (orderingType) {
            case KetteBestellTyp.Undefined:
                return undefined;
            case KetteBestellTyp.Kette:
            case KetteBestellTyp.KetteAlternative: {
                if (!ketteJson.Teilung_mm) {
                    throw new Error(`${this.className}.calculateBasePricePerLength: Teilung_mm is not set`);
                }
                // for KetteBestellTyp.Kette we get basePrice as e.g. 0,14 EUR/Kettenglied
                const length = calculationType === KetteBasePriceCalculationType.PerExactLength
                    ? 1000 / ketteJson.Teilung_mm
                    : Math.ceil(1000 / ketteJson.Teilung_mm);
                return length * basePrice;
            }
            case KetteBestellTyp.KetteUK: {
                if (!ketteJson.Teilung_mm) {
                    throw new Error(`${this.className}.calculateBasePricePerLength: Teilung_mm is not set`);
                }
                // for KetteBestellTyp.KetteUK we get basePrice as e.g. 43,72 GBP/m
                if (calculationType === KetteBasePriceCalculationType.PerExactLength)
                    return basePrice;
                const ukPricePerKettenglied = basePrice * (ketteJson.Teilung_mm / 1000);
                return ukPricePerKettenglied * Math.ceil(1000 / ketteJson.Teilung_mm);
            }
            case KetteBestellTyp.KetteUS: {
                if (!ketteJson.Teilung_mm) {
                    throw new Error(`${this.className}.calculateBasePricePerLength: Teilung_mm is not set`);
                }
                // for KetteBestellTyp.KetteUK we get basePrice as e.g. 17.50 USD/ft
                if (calculationType === KetteBasePriceCalculationType.PerExactLength)
                    return basePrice;
                const teilung_ft = echain_shared_quantities_1.Length.fromJson({ Unit: echain_shared_quantities_1.LengthUnits.mm, Value: ketteJson.Teilung_mm }).ft;
                const usPricePerKettenglied = basePrice * teilung_ft;
                return usPricePerKettenglied * Math.ceil(1 / teilung_ft);
            }
            default:
                (0, echain_shared_logging_1.getLogger)().warn(`${this.className}.calculateBasePricePerLength: Wrong Bestelltyp '${orderingType}'.`, {
                    kette: (_a = ketteJson.ArtNr) === null || _a === void 0 ? void 0 : _a['DE'],
                });
                return undefined;
        }
    }
    /**
     * Retrieves whether the Kette has any GewichtKgProM property defined greater than 0.
     */
    static hasValidGewichtKgProM(ketteJson) {
        var _a, _b, _c;
        const value = (_c = (_b = (_a = ketteJson.GewichtKgProM) === null || _a === void 0 ? void 0 : _a.Value) !== null && _b !== void 0 ? _b : ketteJson.GewichtKgProM_kg_m) !== null && _c !== void 0 ? _c : 0;
        return value > 0;
    }
    static getESkinAeExcessLength(kette) {
        var _a;
        if (!((_a = kette.SerieRef) === null || _a === void 0 ? void 0 : _a.Kuerzel)) {
            throw new Error(`${this.className}.getESkinAeExcessLength: serieRef not set correct`);
        }
        if (!(0, Eskin_1.isEskin)(kette)) {
            throw new Error(`${this.className}.getESkinAeExcessLength: Kette is not a e-skin`);
        }
        const excessLength = eSkinAeExcessLengthMap_1.eSkinAeExcessLengthMap.get(kette.SerieRef.Kuerzel);
        if (excessLength) {
            return echain_shared_quantities_1.Length.mm(excessLength);
        }
        throw new Error(`${this.className}.getESkinAeExcessLength: Invalid excessLength`);
    }
}
exports.KetteJsonUtil = KetteJsonUtil;
KetteJsonUtil.className = 'KetteJsonUtil';
//# sourceMappingURL=KetteJsonUtil.js.map